import React, { useMemo, useEffect } from 'react';
import { commonBackInfo } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { newsDataSourcePlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { newsDataSourceIconMap } from '@op/constants/news';
import './index.scss';

export default function NewsDataSourceSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  const basicOptions = useMemo(() => {
    if (filterOptions) {
      return (filterOptions || [])?.map((item: any) => {
        return {
          text: (
            <div className="dbo-inlineflex">
              {
                <img
                  style={{ width: 20, height: 16, marginRight: 4 }}
                  src={newsDataSourceIconMap[item]}
                />
              }
              {item}
            </div>
          ),
          value: item,
        };
      });
    }
    return [];
  }, [filterOptions]);
  const { formatMessage } = useIntl();

  const {
    selects: newsDataSource,
    setSelects: setNewsDataSource,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'news_data_source',
    options: basicOptions?.map((item: { value: any }) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    let news_data_source = isAll ? [] : newsDataSource;

    onChange?.(
      'newsDataSource',
      commonBackInfo(
        { news_data_source },
        { newsDataSource: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [newsDataSource, formatMessage]);

  return (
    <div className={`news-data-source-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={newsDataSourcePlaceholder[lang]}
        options={basicOptions}
        basicOptions={basicOptions}
        selectOptionsInfo={[newsDataSource, setNewsDataSource]}
        onClear={() => setNewsDataSource([])}
        pointKey={FilterButtonPoint.newsDataSource}
        boxClassName="dbo-news-data-source-select"
      ></CustomSelect>
    </div>
  );
}
